'use strict';

require('./salary-basis.scss');

module.exports = {
  template: require('./salary-basis.html'),
  controller: require('./salary-basis.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<',
    round: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-basis/index.js
 ** module id = 229
 ** module chunks = 0
 **/